
import { useState, useEffect, useMemo } from "react";
import MainLayouts from "../../Layout/MainLayouts";
import { ReactComponent as ArrowLeftCircleLeftFill } from "bootstrap-icons/icons/arrow-left-circle-fill.svg";
import { ReactComponent as ArrowRightCircleLeftFill } from "bootstrap-icons/icons/arrow-right-circle-fill.svg";
import { ReactComponent as ChevronRightIcon } from "bootstrap-icons/icons/chevron-right.svg";
import Spinner from "../spinner/Spinner";
import { useNavigate } from "react-router-dom";
import { handleError } from "../../components/utils/AuthenticationCheck";
import PhysicalProCard from "./PhysicalProCard";
import { usePhysicalProducts } from "../../hooks/useAppData";

const PhysicalProductList = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [productsPerPage] = useState(12);
  const [filterText, setFilterText] = useState("");

  const navigate = useNavigate();

  const { data: physicalResponse, isLoading: loading } = usePhysicalProducts();

  const excludedKeys = ["created_at", "updated_at", "id", "name"];
  const discountObject = physicalResponse?.data?.discounts || {};
  const allProducts = Object.entries(discountObject)
    .filter(([key]) => !excludedKeys.includes(key))
    .map(([key, value]) => ({
      id: key,
      name: key.replace(/_/g, " ").toUpperCase(),
      discount: value,
    }));

  useEffect(() => {
    setCurrentPage(1);
  }, [filterText]);

  const filtered = filterText.trim()
    ? allProducts.filter(item =>
        item.name.toLowerCase().includes(filterText.toLowerCase().trim()) ||
        item.discount.toString().includes(filterText.toLowerCase().trim())
      )
    : allProducts;

  const sorted = [...filtered].sort((a, b) => a.name.localeCompare(b.name));
  const totalProducts = sorted.length;
  const indexOfLast = currentPage * productsPerPage;
  const indexOfFirst = indexOfLast - productsPerPage;
  const products = sorted.slice(indexOfFirst, indexOfLast);

  const hasPrevPage = currentPage > 1;
  const hasNextPage = currentPage * productsPerPage < totalProducts;

  const handlePageChange = (page) => setCurrentPage(page);
  const handleSearchChange = (event) => setFilterText(event.target.value);

  return (
    <div>
      <MainLayouts>
        <div className="relative overflow-x-auto sm:rounded-lg py-6 w-full">
          <section
            className="w-full pl-[3%] pr-[3%] pt-3 my-3"
            style={{ backgroundColor: "#F7F7F7" }}
          >
            <nav className="bg-gray-200 py-0 px-4 rounded-lg ">
              <ol className="list-none p-0 inline-flex mb-2">
                <li className="flex items-center">
                  <p className="text-blue-500 hover:text-blue-600 text-darkGreen3 ">
                    Bills Product Discount
                  </p>
                  <ChevronRightIcon />
                </li>
                <li className="flex items-center">
                  <p className="text-orange1">List</p>
                </li>
              </ol>
            </nav>
          </section>

          <div className="pb-4 bg-white flex flex-wrap items-center justify-between gap-4">
            <div className="relative w-full sm:w-1/2 mb-4 sm:mb-0">
              <input
                type="search"
                className="block w-full px-3 py-2 text-md text-gray-900 border border-gray-300 rounded-lg bg-gray-50"
                placeholder="Search"
                value={filterText}
                onChange={handleSearchChange}
              />
            </div>
          </div>

          {loading ? (
            <Spinner loading={loading} />
          ) : (
            <section className="text-gray-600 body-font">
              <div className="container px-1 py-2 mx-auto">
                <div className="flex flex-wrap -m-2 capitalize">
                  {products.length > 0 ? (
                    products.map((product) => (
                      <PhysicalProCard
                        key={product.id}
                        product={product}
                      />
                    ))
                  ) : (
                    <div className="w-full text-center">No products found</div>
                  )}
                </div>

                {/* Pagination */}
                <div className="flex justify-end mt-6">
                  <nav aria-label="Page navigation">
                    <ul className="pagination flex mx-auto">
                      <li className={`page-item ${!hasPrevPage ? "disabled" : ""}`}>
                        <button
                          className="text-dGrey3 bg-black2 hover:bg-darkGreen2 rounded-full text-sm px-5 py-2 inline-flex items-center gap-1 m-2"
                          onClick={() => handlePageChange(currentPage - 1)}
                          disabled={!hasPrevPage}
                        >
                          <ArrowLeftCircleLeftFill className="w-5 h-5 mr-2" />
                          Prev
                        </button>
                      </li>
                      <li className={`page-item ${!hasNextPage ? "disabled" : ""}`}>
                        <button
                          className="text-dGrey3 bg-black2 hover:bg-darkGreen2 rounded-full text-sm px-5 py-2 inline-flex items-center gap-1 m-2"
                          onClick={() => handlePageChange(currentPage + 1)}
                          disabled={!hasNextPage}
                        >
                          Next
                          <ArrowRightCircleLeftFill className="w-5 h-5 ml-2" />
                        </button>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
            </section>
          )}
        </div>
      </MainLayouts>
    </div>
  );
};

export default PhysicalProductList;


